import type { IRecording } from '@carboncopyco/types';
import {
  dateUTCFromNow,
  dateUtcFromTime,
  formatPlural,
} from '@carboncopyco/utils';
import dayjs from 'dayjs';
import type { ManipulateType } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useMemo } from 'react';

dayjs.extend(utc);

const unitsToAdjust = ['second', 'seconds', 'minute', 'minutes', 'few'];
const adjustAmount = (amount) =>
  amount === 'a' || amount === 'an' ? 1 : amount;
const adjustResult = (result: string) => {
  if (!result) {
    return null;
  }
  const [time, unit] = result.split(' ');
  const resultTime = adjustAmount(time);
  const joinedResult = [resultTime, unit].join(' ');
  return unitsToAdjust.includes(unit) ? '1 hour' : joinedResult;
};

export const useTimeLeftToEditClone = (clone: IRecording, ldFlag: number) => {
  return useMemo(() => {
    if (ldFlag && clone.createTime) {
      const diffInHours = dayjs.utc().diff(dayjs.utc(clone.createTime), 'hour');
      const timeLimitInHours = ldFlag * 24;
      const oneDayRemaining =
        diffInHours < timeLimitInHours && diffInHours > timeLimitInHours - 24;

      if (diffInHours > timeLimitInHours) {
        return null;
      }
      if (oneDayRemaining) {
        const timeAmount = timeLimitInHours - diffInHours;
        return `${timeAmount} ${formatPlural('hour', timeAmount)}`;
      }

      const [amount, timeUnit] = dateUTCFromNow(clone.createTime, true).split(
        ' '
      );
      const timeRemaining = dayjs
        .utc(clone.createTime)
        .add(ldFlag, 'day')
        .subtract(adjustAmount(amount), timeUnit as ManipulateType);
      const result = dateUtcFromTime(clone.createTime, timeRemaining, true);
      return adjustResult(result);
    }
    return null;
  }, [clone, ldFlag]);
};
